import React, { useState } from 'react'
import { StyleSheet, View, TextInput } from 'react-native'
import PropTypes from 'prop-types'
import Icon from '../Icons'
import { useTheme } from '../../theming/ThemeProvider'
import Identity from '../../utils/Identity'
import Txt from '../Txt'
import { TouchableOpacity } from 'react-native-gesture-handler'
import { usePlatforms } from '../../hooks/usePlatforms'

export default function InputFormik ({
  letfIcon, rightIcon, label, error, revealPassword, name, onChange, value,
  ...props
}) {
  const [show, setShow] = useState(!revealPassword)
  const { theme } = useTheme()
  const { isTablet } = usePlatforms()
  const styles = useStyles(theme)

  const renderIcon = (icon, _styles) => (
    <View style={_styles}>
      {typeof icon === 'function' ? (
        icon()
      ) : (
        <Icon
          name={icon}
          height={16}
          width={16}
          fill={theme.ICON_COLOR}
        />)}
    </View>
  )

  const renderRevealPassword = () => (
    <TouchableOpacity activeOpacity={0.8} onPress={() => setShow(prev => !prev)}>
      <Icon
        name='Eye'
        fill={!show ? theme.GEYSER : theme.BUNKER}
        height={20}
        width={20}
      />
    </TouchableOpacity>
  )

  const handleChange = text => {
    onChange(name, text)
  }

  return (
    <View>
      {Boolean(label) && (
        <Txt
          text={label}
          identity='body3Bold'
          style={styles.label}
          numberOfLines={1}
        />
      )}
      <View
        style={styles.container}
      >
        <View
          style={[
            styles.inputContainer,
            error
              ? Identity.Borders(theme).Error
              : Identity.Borders(theme).Normal,
            { backgroundColor: props.editable === false ? theme.DISABLED_INPUT_COLOR : theme.WHITE }
          ]}
        >
          {Boolean(letfIcon) && renderIcon(letfIcon, styles.letfIcon)}
          <TextInput
            placeholderTextColor={theme.SLATE_GRAY}
            pointerEvents={props.onPress ? 'none' : 'auto'}
            style={[
              styles.input,
              Identity.Font(isTablet).body2
            ]}
            secureTextEntry={!show}
            onChangeText={handleChange}
            value={value ? '' + value : ''}
            {...props}
          />
          {Boolean(rightIcon || revealPassword) &&
          renderIcon(revealPassword ? renderRevealPassword : rightIcon, styles.rightIcon)}
        </View>
        {Boolean(error) && (
          <Txt
            text={error}
            identity='body3'
            numberOfLines={1}
            style={styles.error}
          />
        )}
      </View>
    </View>
  )
}
const useStyles = theme => StyleSheet.create({
  letfIcon: {
    marginLeft: 15,
    padding: 0,
    overflow: 'hidden'
  },
  rightIcon: {
    marginRight: 15,
    marginLeft: 5
  },
  container: {
    paddingHorizontal: 0,
    height: 60
  },
  label: {
    marginBottom: 10
  },
  inputContainer: {
    width: '100%',
    height: 40,
    flexDirection: 'row',
    alignItems: 'center'
  },
  input: {
    marginHorizontal: 10,
    color: theme.BUNKER,
    flex: 1
  },
  error: {
    margin: 0,
    marginTop: 3,
    color: theme.RED_ORANGE
  }
})

InputFormik.defaultProps = {
  letfIcon: '',
  rightIcon: '',
  label: '',
  error: '',
  revealPassword: false
}

InputFormik.propTypes = {
  letfIcon: PropTypes.any,
  rightIcon: PropTypes.any,
  label: PropTypes.string.isRequired,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),
  editable: PropTypes.bool,
  onPress: PropTypes.func,
  revealPassword: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
}
